import { useDataProvider, useNotify, useTranslate } from 'react-admin';
import { AVATARS, YOURLS } from '../../../providers/resources';
import { openBackofficeApp } from '../../../utils/backofficeApp';
import { Avatar, MC } from '../../../utils/types';

/** Opens the field app of an installation, from its avatar id: the actions of a table row. */
const useAvatarAppLinks = () => {
    const t = useTranslate();
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const getYourlsDataByAvatarId = (avatarId: string, callback: (mcUrl: string) => void) => {
        dataProvider
            .getList(AVATARS, {
                filter: { id: `/api/avatars/${avatarId}`, serialization_groups: ['read_mc'] },
                pagination: { page: 1, perPage: 1 },
                sort: { field: 'id', order: 'ASC' },
            })
            .then(({ data }: any) => {
                if (Array.isArray(data) && data.length > 0) {
                    const avatar: Avatar = data[0];
                    const mcs = avatar && 'mcs' in avatar ? avatar.mcs : [];
                    if (mcs.length >= 1) {
                        const mc: MC | string = mcs[0];
                        if (typeof mc !== 'string' && 'yourls' in mc) {
                            dataProvider
                                .getOne(YOURLS, { id: mc.yourls })
                                .then(({ data }) => {
                                    if (data && 'mcUrl' in data && data.mcUrl) {
                                        callback(data.mcUrl as string);
                                    }
                                })
                                .catch(() => notify(t('app.ancs.error.server'), 'error'));
                        }
                    }
                }
            })
            .catch(() => notify(t('app.ancs.error.server'), 'error'));
    };

    const simulateFingerMc = (avatarId: string) => {
        getYourlsDataByAvatarId(avatarId, (mcUrl) => window.open(mcUrl, '_blank', 'width=411px,height=731px'));
    };

    const openBackofficeForms = (avatarId: string) => {
        getYourlsDataByAvatarId(avatarId, (mcUrl) =>
            openBackofficeApp(mcUrl, 'forms', {
                onMissingRefreshToken: () => notify(t('app.ancs.backofficeMissingRefresh'), 'warning'),
            }),
        );
    };

    return { simulateFingerMc, openBackofficeForms };
};

export default useAvatarAppLinks;
